export default "__VITE_ASSET__4426ada6__"